import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Dropdown from "components/Dropdown/Dropdown";
import InputField from "components/forms/InputField/InputField";
import Loading from "components/loading/Loading";
import RelativeInfobox from "components/RealtiveInfoBox/RelativeInfobox";
import { useUser } from "hooks/useUser";
import { useEffect, useState } from "react";
import DeleteBusinessButton from "../../../../components/forms/DeleteBusiness/DeleteBusinessButton";
import { url } from "../../../../url";
import styles from "../../../BusinsessRegistration/businessregistration.module.scss";
import { breedTypes, statesTypes } from "utils/enums";

interface BreederFormData {
  name: string;
  description: string;
  email: string;
  phone: number | undefined;
  street: string;
  apartment: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export default function Kennel() {
  const [businessError, setBusinessError] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [stateError, setStateError] = useState<string>("");
  const [errorBreedType, setErrorBreedType] = useState<string>("");
  const { setDataChangeStatus, setIsError, userData } = useUser();
  const [breederFormData, setBreederFormData] = useState<BreederFormData>({
    name: "",
    description: "",
    email: "",
    phone: undefined,
    street: "",
    apartment: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  });

  const [stateType, setStateType] = useState<string>("Województwo");
  const [breedType, setBreedType] = useState<string>("Typ hodowli");

  const getBusinessData = async () => {
    let response;
    try {
      response = await axios.get(url + "/user/business", {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
    } catch (error: any) {
      response = error.response;
      console.log(response);
    }
    return response.data.business;
  };

  const handleBreederChange = (event: any) => {
    const { name, value } = event.target;
    setBreederFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleBreederTypeChange = (key: string, value: string) => {
    setBreederFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleFormSubmit = async (event: any) => {
    setBusinessError("");
    setEmailError("");
    setStateError("");
    const token = localStorage.getItem("token");

    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(breederFormData.email)) {
      setEmailError("Prosze podać poprawny adres email.");
      event.preventDefault();
      return;
    }
    if (token) {
      mutate({ formData: breederFormData });
      event.preventDefault();
    }
    event.preventDefault();
  };

  const changeBusiness = async ({
    formData,
  }: {
    formData: BreederFormData;
  }) => {
    let response;
    try {
      response = await axios.patch(url + "/user/business", formData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
    } catch (error: any) {
      response = error.response;
      console.log(response);
    }
    return response.data.business;
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["business"],
    queryFn: () => getBusinessData(),
  });

  const { mutate } = useMutation({
    mutationFn: changeBusiness,
    onSuccess: (data: any) => {
      console.log(data.message);
      if (data.status === 500) {
        if (
          data.message ===
          "Breeder validation failed: state: `` is not a valid enum value for path `state`."
        ) {
          setStateError("Wybierz województwo");
        }
      } else {
        setDataChangeStatus(`Udało się zmienić dane!`);
        setIsError(false);
      }
    },
  });

  useEffect(() => {
    if (data) {
      setBreederFormData({
        name: data.name,
        description: data.description,
        email: data.email,
        phone: data.phone,
        street: data.street,
        apartment: data.apartment,
        city: data.city,
        state: data.state,
        zipCode: data.zipCode,
        country: data.country,
      });
      setBreedType(data.type);
      setStateType(data.state);
    }
  }, [data]);

  return (
    <>
      {!isLoading ? (
        <>
          <form className={styles.box__form} onSubmit={handleFormSubmit}>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Nazwa hodowli"}
                name={"name"}
                value={breederFormData.name}
                onChange={handleBreederChange}
                error={""}
                type={"text"}
                required
                length={100}
              />
              <Dropdown
                dropButtonName={breedType}
                dropDownData={breedTypes}
                setButtonName={setBreedType}
                handleChange={handleBreederTypeChange}
                changeType="type"
                error={errorBreedType}
              />
            </div>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Adres email"}
                name={"email"}
                value={breederFormData.email}
                onChange={handleBreederChange}
                error={emailError}
                type={"text"}
                required
                length={254}
              />
              <InputField
                label={"Numer telefonu"}
                name={"phone"}
                value={breederFormData.phone}
                onChange={handleBreederChange}
                error={""}
                type={"number"}
                required
                length={15}
              />
            </div>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Ulica"}
                name={"street"}
                value={breederFormData.street}
                onChange={handleBreederChange}
                error={""}
                type={"text"}
                required
                length={100}
              />
              <InputField
                label={"Numer budynku"}
                name={"apartment"}
                value={breederFormData.apartment}
                onChange={handleBreederChange}
                error={""}
                type={"text"}
                required={false}
                length={10}
              />
            </div>
            <div className={styles.box__inputBox}>
              <InputField
                label={"Kod pocztowy"}
                name={"zipCode"}
                value={breederFormData.zipCode}
                onChange={handleBreederChange}
                error={""}
                type={"text"}
                required
                length={11}
              />
              <InputField
                label={"Miasto"}
                name={"city"}
                value={breederFormData.city}
                onChange={handleBreederChange}
                error={""}
                type={"text"}
                required
                length={58}
              />
            </div>
            <div className={styles.box__inputBox}>
              <Dropdown
                dropButtonName={stateType}
                dropDownData={statesTypes}
                setButtonName={setStateType}
                handleChange={handleBreederTypeChange}
                changeType="state"
                error={stateError}
              />
              <InputField
                label={"Państwo"}
                name={"country"}
                value={breederFormData.country}
                onChange={handleBreederChange}
                error={""}
                type={"text"}
                required
                length={56}
              />
            </div>
            <InputField
              label={"Opis hodowli"}
              name={"description"}
              value={breederFormData.description}
              onChange={handleBreederChange}
              error={""}
              type={"text"}
              required
              length={1000}
            />
            {/* textarea zamiast tego */}
            {/* <RelativeInfobox /> */}
            <button className={styles.box__changeData} type="submit">
              Zmień dane
            </button>
          </form>
          <DeleteBusinessButton
            label={"Czy na pewno chcesz usunąć działalność?"}
          />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}
